import { BusinessRim } from './rim-business.model';

export enum BusinessResultType { ok, error, warning }
export enum BusinessValidationType { none, ibanRim, ibanSvs, hnStructuredMessage }

export interface BusinessValidation {
    businessValidationType: BusinessValidationType;
    hasError: boolean;
    errorMessage: string;
}
export interface BusinessResult {
    resultType: BusinessResultType;
    messages: string[];
    data: BusinessPolicy | null;
    validations: BusinessValidation[];
}

export interface BusinessSvsLine {
    id: number;
    amount: number;
    description: string;
    sequence: number;
    svsHeaderID: number;
    deleted: boolean;
    isImportFromDacca: boolean;
}

export interface BusinessSvs {
    id: number;
    hasDaccaCaluclation: boolean;
    excessApplicableTCchecked: boolean;
    underConditionTCchecked: boolean;
    svsLines: BusinessSvsLine[];
    currentLine: BusinessSvsLine;
    svsTotal: number;
    damageCauseRemark: string;

    tabIsValid: boolean;

    damageCauseRemarkIsValid: boolean;
    excessApplicableIsValid: boolean;
    underConditionIsValid: boolean;
    iban: string;
    financialAccountNumber: string;
    sendEmailToPolicyHolder: boolean;
    emailPolicyHolder: string;
    sendEmailToCounterExpert: boolean;
    emailCounterExpert: string;
    sendEmailToPersonalExpert: boolean;
    emailPersonalExpert: string;
    sendEmailToOther: boolean;
    emailOther: string;
}

export interface BusinessPolicy {
    id: number;
    insurerPartyName: string;
    contractNumber: number;
    contractClassification: string;
    contractName: string;
    conditions: string;
    dateOfCommencement: Date | '';
    dateOfExpiration: Date | '';
    indirectLossesPercentage: number;
    legalExcessAmount: number;
    excessAmount: number;
    raisedExcessAmount: number;
    loweredExcessAmountThreshold: number;
    indirectLossesBuilding: boolean;
    indirectLossesContent: boolean;
    guaranteeTCBuilding: string;
    guaranteeTCContent: string;
    policySubTypeTC: string;
    policyTypeTC: string;
    policyHolderLanguageTC: string;
    Svs: BusinessSvs;
    Rim: BusinessRim;
}

export function createDefaultBusinessPolicy(): BusinessPolicy {
    return {
      id: 0,
      insurerPartyName: '',
      contractNumber: 0,
      contractClassification: '',
      contractName: '',
      conditions: '',
      dateOfCommencement: '',
      dateOfExpiration: '',
      indirectLossesPercentage: 0,
      legalExcessAmount: 0,
      excessAmount: 0,
      raisedExcessAmount: 0,
      loweredExcessAmountThreshold: 0,
      indirectLossesBuilding: false,
      indirectLossesContent: false,
      guaranteeTCBuilding: '',
      guaranteeTCContent: '',
      policySubTypeTC: '',
      policyTypeTC: '',
      policyHolderLanguageTC: '',
      Svs: {
        id: 0,
        hasDaccaCaluclation: false,
        excessApplicableTCchecked: false,
        underConditionTCchecked: false,
        svsLines: [],
        currentLine: {
          id: 0,
          amount: 0,
          description: '',
          sequence: 0,
          svsHeaderID: 0,
          deleted: false,
          isImportFromDacca: false,
        },
        svsTotal: 0,
        damageCauseRemark: '',
        tabIsValid: false,
        damageCauseRemarkIsValid: false,
        excessApplicableIsValid: false,
        underConditionIsValid: false,
        iban: '',
        financialAccountNumber: '',
        sendEmailToPolicyHolder: false,
        emailPolicyHolder: '',
        sendEmailToCounterExpert: false,
        emailCounterExpert: '',
        sendEmailToPersonalExpert: false,
        emailPersonalExpert: '',
        sendEmailToOther: false,
        emailOther: '',
      },
      Rim: {
        id: 0,
        currentRimLine: {
        id: 0,
        sequence: 0,
        amount: '',
        description: '',
        vatPercentageTC: '',
        vatThresholdTC: '',
        amount80: '',
        invoicePresent: false,
        rimSectionTC: '',
        rimItemTC: '',
        vatEnabled: false,
        vatPercentageEnabled: false,
        amountEnabled: false,
        invoicePresentEnabled: false,
        rimItemValuesBySection: [],
        deleted: false,
        isImportFromDacca: false,
        },
        rimLines: [],
        deductibleVatPercentage: '',
        vat6ToBeJustifiedAmount: '',
        vat21ToBeJustifiedAmount: '',
        paidByBankTransfer: false,
        bban: '',
        iban: '',
        bicCode: '',
        rimLinesAmountTotal: 0,
        rimLinesAmount80Total: 0,
        vatThresholdValues: [],
        vatPercentageValues: [],
        rimSectionValues: [],
        rimItemValues: [],
        damageCauseRemark: '',
        sendEmailToPolicyHolder: '',
        emailPolicyHolder: '',
        sendEmailToCounterExpert: '',
        emailCounterExpert: '',
        sendEmailToPersonalExpert: '',
        emailPersonalExpert: '',
        sendEmailToOther: '',
        emailOther: '',
        rimStatusTC: ''
      },
    };
  }